export default __webpack_public_path__ + "static/media/Ask-A-Medical-Expert_580x400_Mother_daughter.2b048ea3.jpg";